module.exports = __webpack_public_path__ + "static/media/splash.e2786143.png";